import Message from "../../message";
import {useMainStore} from "@/store";

export default class MemberPromoted extends Message
{
    handle()
    {
        useMainStore().PROMOTE_GUILD_MEMBER(this.message.user_id);
    }
}
